import { render, staticRenderFns } from "./aiCustomPageChatView.vue?vue&type=template&id=cb1f68d4&scoped=true&"
import script from "./aiCustomPageChatView.vue?vue&type=script&lang=js&"
export * from "./aiCustomPageChatView.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPageChatView.vue?vue&type=style&index=0&id=cb1f68d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1f68d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1f68d4')) {
      api.createRecord('cb1f68d4', component.options)
    } else {
      api.reload('cb1f68d4', component.options)
    }
    module.hot.accept("./aiCustomPageChatView.vue?vue&type=template&id=cb1f68d4&scoped=true&", function () {
      api.rerender('cb1f68d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPageChatView.vue"
export default component.exports